// extracted by mini-css-extract-plugin
module.exports = {"pad":"privacy-module--pad--mTFDl","main":"privacy-module--main--uuWtW","heading":"privacy-module--heading--3f3FY","mono":"privacy-module--mono--2k6eK"};